export default "__VITE_ASSET__3d93cbb8__"